"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlagIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var SVGBox_1 = require("./SVGBox");
var RegularSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, size = _a.size, rest = __rest(_a, ["fill", "size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 24 26" }, rest, { children: [jsx_runtime_1.jsx("path", { d: "M2.5 2V1.5H2V2H2.5ZM2.5 16H2V16.5H2.5V16ZM19.067 8.00772L18.6329 7.75965L19.067 8.00772ZM19.067 9.99228L18.6329 10.2403L19.067 9.99228ZM21.6451 3.49614L21.2109 3.24807L21.6451 3.49614ZM2.5 2.5H20.7768V1.5H2.5V2.5ZM2 2V16H3V2H2ZM20.7768 15.5H2.5V16.5H20.7768V15.5ZM21.2109 3.24807L18.6329 7.75965L19.5011 8.25579L22.0792 3.74421L21.2109 3.24807ZM18.6329 10.2403L21.2109 14.7519L22.0792 14.2558L19.5011 9.74421L18.6329 10.2403ZM18.6329 7.75965C18.1937 8.52823 18.1937 9.47177 18.6329 10.2403L19.5011 9.74421C19.2376 9.28306 19.2376 8.71694 19.5011 8.25579L18.6329 7.75965ZM20.7768 16.5C21.9286 16.5 22.6506 15.2558 22.0792 14.2558L21.2109 14.7519C21.4014 15.0853 21.1607 15.5 20.7768 15.5V16.5ZM20.7768 2.5C21.1607 2.5 21.4014 2.91474 21.2109 3.24807L22.0792 3.74421C22.6506 2.74422 21.9286 1.5 20.7768 1.5V2.5Z", fill: "black" }, void 0),
            jsx_runtime_1.jsx("path", { d: "M2.5 1V25", stroke: "black", strokeLinecap: "round", fill: fill }, void 0)] }), void 0));
};
var BigSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, size = _a.size, rest = __rest(_a, ["fill", "size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 32 34" }, rest, { children: [jsx_runtime_1.jsx("path", { d: "M27.7023 2.33334H3.33325V21H27.7023C28.7261 21 29.3679 19.894 28.86 19.0052L25.4226 12.9897C24.9541 12.1699 24.9541 11.1635 25.4226 10.3436L28.86 4.3282C29.3679 3.43932 28.7261 2.33334 27.7023 2.33334Z", stroke: "black", strokeWidth: "1.5" }, void 0),
            jsx_runtime_1.jsx("path", { d: "M3.25 1V33", stroke: "black", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", fill: fill }, void 0)] }), void 0));
};
var FlagIcon = function (props) {
    var _a = props.size, size = _a === void 0 ? 24 : _a, rest = __rest(props, ["size"]);
    return size < 32 ? (jsx_runtime_1.jsx(RegularSizedIcon, __assign({ size: size }, rest), void 0)) : (jsx_runtime_1.jsx(BigSizedIcon, __assign({ size: size }, rest), void 0));
};
exports.FlagIcon = FlagIcon;
//# sourceMappingURL=FlagIcon.js.map